<template lang='pug'>
    #card-filtros-dashboard-operacao
        card
            el-collapse(style='border: none' v-model="expandFilter")
                el-collapse-item(name='1')
                    .titulo(slot="title")
                        i(class="mdi mdi-filter-variant filter-icon")
                        span {{ $t('mensagens.comuns.filtros') }}

                    el-form.row(
                        label-position="top",
                        size="medium"
                    )
                        el-form-item.col-3
                            span.label(slot="label") {{ $t('mensagens.comuns.empresas') }}
                            el-select.w-100(
                                v-model="idsEmpresas"
                                multiple filterable collapse-tags
                                :placeholder="$t('mensagens.operacao.acoes.selecione')"
                            )
                                el-option(
                                    v-for="item in empresasOptions"
                                    :key="item.id"
                                    :label="item.nome"
                                    :value="item.id"
                                )
                                    span(:style="item.id === 'selecionar_todos' ? 'font-weight: 600; color: #00413c' : ''") {{ item.nome }}
                        el-form-item.col-3
                            span.label(slot="label") {{ $t('mensagens.operacao.dashboard.dataCadastro') }}
                            el-date-picker.w-100(
                                v-model="dataCadastro"
                                type='daterange',
                                range-separator='-',
                                format="dd-MM-yyyy"
                                :start-placeholder="$t('mensagens.operacao.listaFiscalizacao.dataInicio')",
                                :end-placeholder="$t('mensagens.operacao.listaFiscalizacao.dataFim')"
                            )
                        el-form-item.col-3
                            span.label(slot="label") {{ $t('mensagens.operacao.dashboard.dataVigencia') }}
                            el-date-picker.w-100(
                                v-model="dataVigencia"
                                type='daterange',
                                range-separator='-',
                                format="dd-MM-yyyy"
                                :start-placeholder="$t('mensagens.operacao.listaFiscalizacao.dataInicio')",
                                :end-placeholder="$t('mensagens.operacao.listaFiscalizacao.dataFim')"
                            )
                        el-form-item.col-3
                            span.label(slot="label") {{ $t('mensagens.operacao.formularioAtividade.produto') }}
                            el-select.w-100(v-model="idsCategorias" multiple :placeholder="$t('mensagens.operacao.acoes.selecione')")
                                el-option(
                                    v-for="item in produtosOptions"
                                    :key="item.id"
                                    :label="item.nome"
                                    :value="item.id"
                                )

                        .form-aplicar-filtros
                            BaseButton(@click='limparFiltros') {{ $t('mensagens.blocoFiltros.uteis.limparFiltro') }}
                            BaseButton(type="primary" @click='aplicarFiltros') {{ $t('mensagens.blocoFiltros.uteis.aplicarFiltros') }}

</template>

<script>
import Card from '@/components/Card.vue';
import OperacaoDashboardService from '@/services/OperacaoDashboardService';
import OperacaoService from '@/services/OperacaoService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

const marcarDesmarcarTodos = 'selecionar_todos';

export default {
    name: 'CardFiltrosDashboardOperacao',

    emits: ['filtrar'],

    components: {
        Card,
        BaseButton
    },

    data() {
        return {
            expandFilter: '1',
            empresasOptions: [],
            produtosOptions: [],
            idsEmpresas: [],
            idsCategorias: [],
            dataCadastro: null,
            dataVigencia: null,
            filtros: {
                idsEmpresas: [],
                idsCategorias: [],
                dataCadastroInicio: null,
                dataCadastroFim: null,
                dataVigenciaInicio: null,
                dataVigenciaFim: null
            }
        };
    },

    watch: {
        idsEmpresas(curr, prev) {
            const possuiaSelecionarTodos = prev.filter(item => item === marcarDesmarcarTodos).length === 1;
            const possuiSelecionarTodos = curr.filter(item => item === marcarDesmarcarTodos).length === 1;

            // seleciona todas as empresas
            if (!possuiaSelecionarTodos && possuiSelecionarTodos) {
                this.idsEmpresas = [];

                this.empresasOptions.forEach(item => {
                    this.idsEmpresas.push(item.id);
                });
                return;
            }

            // tira selecao de todas as empresas
            if (possuiaSelecionarTodos && !possuiSelecionarTodos && this.empresasOptions.length - 1 === this.idsEmpresas.length) {
                this.idsEmpresas = [];
                return;
            }

            // desmarca opcao 'Selecionar todos'
            if (possuiaSelecionarTodos && this.empresasOptions.length !== this.idsEmpresas.length) {
                this.idsEmpresas = this.idsEmpresas.filter(item => item !== marcarDesmarcarTodos);
            }
        }
    },

    mounted() {
        this.buscarEmpresas();
        this.buscarCategorias();
    },

    methods: {
        aplicarFiltros() {
            if (this.dataCadastro) {
                this.filtros.dataCadastroInicio = this.dataCadastro[0].toLocaleDateString('pt-BR');
                this.filtros.dataCadastroFim = this.dataCadastro[1].toLocaleDateString('pt-BR');
            }
            if (this.dataVigencia) {
                this.filtros.dataVigenciaInicio = this.dataVigencia[0].toLocaleDateString('pt-BR');
                this.filtros.dataVigenciaFim = this.dataVigencia[1].toLocaleDateString('pt-BR');
            }

            this.filtros.idsEmpresas = this.idsEmpresas;
            this.filtros.idsEmpresas = this.idsEmpresas.filter(item => item !== marcarDesmarcarTodos);
            this.filtros.idsCategorias = this.idsCategorias;

            this.$emit('filtrar', this.filtros);
        },

        async buscarEmpresas() {
            try {
                const { data } = await OperacaoDashboardService.buscarEmpresas();
                this.empresasOptions = data.itens;
                this.empresasOptions.unshift({ id: marcarDesmarcarTodos, nome: this.$t('mensagens.operacao.dashboard.marcarDesmarcar') });
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.erroBuscaEmpresa')
                });
            }
        },

        async buscarCategorias() {
            try {
                const { data } = await OperacaoService.buscarCategorias();
                this.produtosOptions = data.itens;
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.erroBuscaCategoria')
                });
            }
        },

        limparFiltros() {
            this.filtros.idsEmpresas = [];
            this.filtros.idsCategorias = [];
            this.filtros.dataCadastroInicio = null;
            this.filtros.dataCadastroFim = null;
            this.filtros.dataVigenciaInicio = null;
            this.filtros.dataVigenciaFim = null;
            this.idsEmpresas = [];
            this.idsCategorias = [];
            this.dataCadastro = null;
            this.dataVigencia = null;

            this.aplicarFiltros();
        }
    }
};
</script>

<style lang='scss'>
#card-filtros-dashboard-operacao {

    #card {
        padding: 15px 20px;
    }

    .titulo {
        display: flex;
        font-size: 16px;
        color: var(--primary);

        i {
            margin-right: 10px;
            font-size: 18px;
        }
    }

    .label {
        font-weight: 500;
    }

    .form-filtros {
        display: flex;
    }

    .form-aplicar-filtros {
        width: 100%;
        margin-top: 20px;
        margin-right: 15px;
        display: flex;
        justify-content: flex-end;
    }

    .el-collapse-item__wrap {
        border-bottom: none;
    }

    .el-collapse-item__content {
        padding-bottom: 0;
    }
}

</style>
